import { requestFile } from '../@utils'
import { request } from '../@utils'
const stockInService = {
  baseQueryPath: '/inventory/stock-in/',
  getStockList: params => {
    return request.post('inventory/stock-in/list', { data: params })
  },
  getStockProductList: params => {
    return request.post('inventory/stock-in/detail-product', { data: params })
  },
  discardStockSheet: no => {
    return request.post(`inventory/stock-in/discard/${no}`)
  },
  exportStockSheet: params => {
    return requestFile.post(`inventory/stock-in/export`, {
      data: params,
      responseType: 'blob'
    })
  },
  getStockDetail: no => {
    return request.get(`inventory/stock-in/detail/${no}`)
  }
}
export default stockInService
